<template>
  <div class="detail-aide">
    <a @click="$router.go(-1)" class="button return-button">
      <img src="../assets/pictos/back-arrow.svg">
      Liste des aides
    </a>
    <transition name="fade" mode="out-in">
      <div v-if="loadingAide"
        class="loading"
        key="loading">
        <img src="../assets/loading.gif" alt="image de chargement">
      </div>
      <div v-else-if="error" key="error">
        <div class="message-wrapper">
          <div class="message error">
            <p class="content">
              {{ error }}
            </p>
          </div>
        </div>
      </div>
      <div v-else key="detail" class="detail-wrapper">
        <div class="description-wrapper">
          <div class="head">
            <div>
              <h2>{{ aide.libelle }}</h2>
              <p>{{ aide.libelle_programme }}</p>
            </div>
            <div>
              <a :href="aide.lien_documentation" class="button doc-button">
                <p>
                  <strong>Consulter</strong><br> la documentation
                </p>
                <img src="../assets/pictos/documentation.svg" alt="image du lien vers la documentation">
              </a>
            </div>
          </div>
          <div class="content">
            <div class="section">
              <p v-if="aide.description_programme">
                {{ aide.description_programme }}
              </p>
              <p v-if="aide.description">
                {{ aide.description }}
              </p>
            </div>
            <div class="montant-wrapper">
              <p class="title">Montant<span v-if="aide.montants.length > 1">s</span> de l'aide</p>
              <montant-aide
                v-for="(montant, index) in aide.montants"
                :key="'montant' + index"
                :montant="montant"
                :detail="true">
              </montant-aide>
              <div class="global-montant" v-if="aide.plafond_globale">
                Jusqu'à {{ aide.plafond_globale.valeur }} {{ aide.plafond_globale.type }}
              </div>
            </div>
          </div>
        </div>
        <div class="conditions-wrapper">
          <div class="head">
            <h2>Les conditions pour obtenir cette aide</h2>
          </div>
          <div class="content">
            <div class="section ressource-section" v-if="aide.tableau_ressources">
              <h3>Les conditions de ressources</h3>
              <table>
                <tr class="text-center">
                  <th>Nombre de personnes composant le ménage</th>
                  <th>Plafonds de ressources (€)</th>
                </tr>
                <tr
                  v-for="(plafond, index) in aide.tableau_ressources.plafonds_par_personnes"
                  :key="index"
                  :class="{'even' : index % 2 === 0}"
                >
                  <td>{{ index }} <img alt="picto personne" class="nb-personne" src="../assets/pictos/picto-people.svg"></td>
                  <td>{{ plafond }} €</td>
                </tr>
                <tr
                  v-if="aide.tableau_ressources.plafond_additionnel_par_personne !== 0"
                  :class="{'even' : Object.keys(aide.tableau_ressources.plafonds_par_personnes).length % 2 === 1}"
                >
                  <td>Plafond additionnel par personne supplémentaire</td>
                  <td>+ {{ aide.tableau_ressources.plafond_additionnel_par_personne }} €</td>
                </tr>
              </table>
            </div>
            <div class="section conditions-section">
              <h3 v-if="aide.tableau_ressources">Autres conditions</h3>
              <h3 v-else>Conditions à remplir :</h3>
              <conditions-aide
                v-if="aide.groupe_racine_programme !== null"
                :conditions="aide.groupe_racine_programme.conditions"
                :groups="aide.groupe_racine_programme.groupes_fils">
              </conditions-aide>
              <conditions-aide
                v-if="aide.groupe_racine !== null"
                :conditions="aide.groupe_racine.conditions"
                :groups="aide.groupe_racine.groupes_fils">
              </conditions-aide>
            </div>
          </div>
        </div>
        <div class="coords-wrapper">
          <div class="head">
            <h2>Coordonnées</h2>
          </div>
          <div class="content">
            <div class="coords">
              <a v-if="aide.site"
                 :href="aide.site"
                 target="_blank"
                 rel="noopener"
                 class="coord-bloc website">
                <p class="link">Consulter le site</p>
              </a>
              <a :href="adressGmapsLink" target="_blank" rel="noopener" class="coord-bloc adress">
                {{ aide.adresse }} <br>
                {{ aide.adresse2 }} <br>
                {{ aide.code_postal }}, {{ aide.ville }}
              </a>
              <div v-if="aide.telephone" class="coord-bloc phone">
                {{ aide.telephone }}
              </div>
              <a v-if="aide.mail" :href="'mailto:' + aide.mail" class="coord-bloc email">
                {{ aide.mail }}
              </a>
            </div>
          </div>
        </div>
        <div class="report-error-wrapper">
          <router-link :to="'/signaler-erreur/' + aide.id" class="button report-button">
            <span>Signaler une erreur</span>
            <img src="../assets/pictos/report-error.svg">
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import MontantAide from '../components/aides/MontantAide'
import aidesService from '../services/AidesService'
import ConditionsAide from '../components/aides/ConditionsAide'

export default {
  name: 'DetailAide',
  props: ['idAide'],
  components: {
    MontantAide,
    ConditionsAide
  },
  data () {
    return {
      loadingAide: true,
      error: '',
      aide: {}
    }
  },
  created () {
    aidesService.getDetailAide(this.idAide)
      .then(response => {
        this.aide = response.data
        this.loadingAide = false
        this.error = ''
      })
      .catch(error => {
        this.loadingAide = false
        this.error = 'Une erreur est survenue lors de la récupération de l\'aide ' + error
      })
  },
  computed: {
    adressGmapsLink () {
      if (!this.loadingAide) {
        return 'https://maps.google.com/?q=' + this.aide.adresse + ',' + this.aide.adresse2 + ',' + this.aide.code_postal + ',' + this.aide.ville
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
.detail-aide {
  position: relative;
  .loading {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 70px;
    }
  }
  .message-wrapper {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h2, h3 {
    margin: 0;
  }
  .head {
    text-align: left;
    padding: 20px 30px;
    background-color: $primary-color;
    color: #fff;
    border-radius: $radius $radius 0 0;
  }
  .detail-wrapper {
    .content {
      background-color: #fff;
      color: $primary-color;
      border-radius: 0 0 $radius $radius;
      padding: 25px $h-spacer-lg 50px $h-spacer-lg;
      .section {
        padding: 0 25px;
        margin: 0 auto;
        text-align: left;
        font-size: $text-size-md;
        line-height: 1.3rem;
        p + p {
          margin-top: $h-spacer-lg;
        }
      }
    }
    .description-wrapper {
      margin-top: $v-spacer-xl;
      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .doc-button {
          width: 184px;
          box-sizing: border-box;
          margin-right: 30px;
          background-image: $primary-gradient;
          color: #fff;
          border-radius: $radius-sm;
          height: 54px;
          padding-left: 10px;
          padding-right: 5px;
          font-size: $text-size;
          font-family: $secondary-font;
          p {
            text-align: center;
            margin-right: 10px;
          }
        }
      }
      .content {
        font-family: $secondary-font;
        .montant-wrapper {
          display: inline-block;
          margin: $v-spacer-lg auto 0 auto;
          p.title {
            font-weight: 700;
            font-size: $text-size-lg;
            text-align: left;
            margin-bottom: 10px;
          }
          .global-montant {
            padding: 10px 0;
            text-align: center;
            background-color: $secondary-color;
            color: #fff;
            font-family: $secondary-font;
            font-size: $text-size;
            border-radius: $radius;
            margin-top: $h-spacer;
          }
          .montant + .montant {
            margin-top: 40px;
            &:before {
              content: '+';
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              position: absolute;
              color: #fff;
              width: 25px;
              height: 25px;
              font-weight: 700;
              font-size: 1.1rem;
              top: -35px;
              left: 50%;
              transform: translateX(-50%);
              background-image: $primary-gradient;
            }
          }
        }
      }
    }
    .conditions-wrapper {
      margin-top: $v-spacer;
      .content {
        h3 {
          background-repeat: no-repeat;
          background-position: left center;
          min-height: 30px;
          display: flex;
          align-items: center;
          padding-left: 50px;
          font-weight: 300;
        }
        .ressource-section {
          h3 {
            background-image: url('../assets/pictos/money.svg');
          }
          table {
            margin: 15px auto;
            text-align: center;
            border-collapse: collapse;
            th, td {
              border: 1px solid #dcdcdc;
              padding: 10px;
              .nb-personne {
                vertical-align: top;
                margin-left: 5px
              }
            }
            th {
              font-weight: inherit;
              background-color: $primary-color;
              color: white;
              padding: 10px;
            }
            td {
              padding: 7px 10px;
            }
            .even {
              background-color: #e5e6e7;
            }
          }
        }
        .conditions-section {
          h3 {
            background-image: url('../assets/pictos/conditions.svg');
          }
        }
      }
    }
    .coords-wrapper {
      margin-top: $v-spacer;
      .content {
        padding: 0;
        .coords {
          display: flex;
          align-items: center;
          justify-content: space-between;
          > .coord-bloc {
            height: 180px;
            padding: 20px $h-spacer-lg 0 $h-spacer-lg;
            display: flex;
            flex-grow: 1;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            background-repeat: no-repeat;
            background-position: top 30px center;
            text-decoration: none;
            color: $primary-color;
            &:not(:last-child) {
              border-right: 1px solid $border-color;
            }
            &.website {
              border-bottom-left-radius: $radius;
              background-image: url('../assets/pictos/website.svg');
            }
            &.adress {
              background-image: url('../assets/pictos/location-pin.svg');
              background-size: 25px 35px;
            }
            &.phone {
              background-image: url('../assets/pictos/phone.svg');
              border-bottom-right-radius: $radius;
            }
            &.email {
              background-image: url('../assets/pictos/mail.svg');
              background-size: 45px;
              border-bottom-right-radius: $radius;
            }
            &:hover {
              background-color: $hover-color;
            }
          }
        }
      }
    }
    .report-error-wrapper {
      background-color: #fff;
      margin-top: $v-spacer;
      padding: $v-spacer-lg;
      .report-button {
        color: $primary-color;
        font-weight: 700;
        width: 160px;
        height: 54px;
        margin: 0 auto;
        border: 1px solid $primary-color;
        border-radius: $radius-sm;
        padding: 0 15px;
        &:hover {
          background-color: $hover-color;
        }
      }
    }
  }
}

@media (max-width: 1020px) {
  .detail-aide {
    .conditions-wrapper .content .conditions-section ul li.is-rge:after {
      content: none;
    }
  }
}
</style>
